exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header-main{position:relative}header-main news-ticker{position:absolute;top:0;left:5.2%;height:28%;width:91%}header-main logo{position:absolute;top:27.5%;width:20.8%;height:72%;left:5.2%;z-index:100}header-main .top-row{background-color:#2c37ab;position:absolute;top:27.5%;width:100%;height:46%}header-main .top-row navbar{position:absolute;left:26%;top:0;bottom:0;right:3.6%}header-main .bottom-row{background-color:#080c73;position:absolute;top:73%;width:100%;height:27%}header-main .bottom-row navbar-sub-menu{position:absolute;top:0;left:26%;right:3.6%;height:100%;opacity:0;transition:opacity .15s linear}header-main .bottom-row navbar-sub-menu a{display:none;outline:none;font-size:0}header-main .bottom-row navbar-sub-menu.show{opacity:1}header-main .bottom-row navbar-sub-menu.show a{display:block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/headerMain/headerMain.scss
 ** module id = 132
 ** module chunks = 0
 **/